import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import EncuestaPage from './pages/EncuestaPage';
import GraciasPage from './pages/GraciasPage';
import NotFoundPage from './pages/NotFoundPage';
import './App.css';

function App() {
  useEffect(() => {
    // Función mejorada para verificar y esperar reCAPTCHA
    const initRecaptcha = () => {
      // Si ya está cargado y listo
      if (window.grecaptcha && typeof window.grecaptcha.ready === 'function') {
        try {
          window.grecaptcha.ready(() => {
            console.log('✅ reCAPTCHA cargado correctamente');
          });
          return true;
        } catch (error) {
          console.warn('⚠️ Error al inicializar reCAPTCHA:', error);
          return false;
        }
      }
      return false;
    };

    // Intentar inmediatamente si ya está disponible
    if (initRecaptcha()) {
      return;
    }

    // Esperar a que el script se cargue desde el HTML
    let attempts = 0;
    const maxAttempts = 100; // 10 segundos (100 * 100ms)
    let checkInterval = null;
    let loadHandler = null;

    const checkRecaptcha = () => {
      attempts++;
      
      if (initRecaptcha()) {
        // Éxito: limpiar intervalos y listeners
        if (checkInterval) {
          clearInterval(checkInterval);
          checkInterval = null;
        }
        if (loadHandler) {
          window.removeEventListener('load', loadHandler);
          loadHandler = null;
        }
        return;
      }

      // Si se agotaron los intentos
      if (attempts >= maxAttempts) {
        if (checkInterval) {
          clearInterval(checkInterval);
          checkInterval = null;
        }
        if (loadHandler) {
          window.removeEventListener('load', loadHandler);
          loadHandler = null;
        }
        console.warn('⚠️ reCAPTCHA no se ha cargado después de 10 segundos.');
        console.warn('   Verifica:');
        console.warn('   1. Tu conexión a internet');
        console.warn('   2. Que el dominio esté autorizado en Google reCAPTCHA Admin');
        console.warn('   3. Que no haya bloqueadores de anuncios activos');
        return;
      }
    };

    // Verificar periódicamente cada 100ms
    checkInterval = setInterval(checkRecaptcha, 100);

    // También escuchar el evento load del window
    loadHandler = () => {
      checkRecaptcha();
      // Después del load, verificar más agresivamente por 2 segundos más
      setTimeout(() => {
        if (checkInterval) {
          clearInterval(checkInterval);
          checkInterval = setInterval(checkRecaptcha, 50); // Verificar cada 50ms
        }
      }, 2000);
    };
    
    window.addEventListener('load', loadHandler);

    // Cleanup
    return () => {
      if (checkInterval) {
        clearInterval(checkInterval);
      }
      if (loadHandler) {
        window.removeEventListener('load', loadHandler);
      }
    };
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/encuesta/:id" element={<EncuestaPage />} />
          <Route path="/gracias" element={<GraciasPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
